import { api } from "@/utils/api";
import { JandiLogo } from "../../../components/assets/logos/svgs";
import { Link, useNavigate } from "react-router-dom";
import { ProgressBarStep1, ProgressBarStep2 } from "../../../components/assets/register/svgs";
import { UpdateWorkerStep1 } from "../../../components/register/update-worker-profile/Step1";
import { UpdateWorkerStep2 } from "../../../components/register/update-worker-profile/Step2";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import type { WorkerProfile } from "../../../types/userTypes";
import { Spinner } from "@/shared/spinner/spinner";

export function UpdateWorkerProfile() {
  const { token, user } = useSelector((state: { user }) => state.user || {});
  const [worker, setWorker] = useState<WorkerProfile>({} as WorkerProfile);
  const [currentStep, setCurrentStep] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if(!token || !user){
      navigate("/")
    }
    else{
      setIsLoading(true)
      api
      .getMe()
      .then((worker) => {
        setWorker(worker)
        setCurrentStep(0)
        setIsLoading(false)
      })
      .catch(() => {
        setWorker({} as WorkerProfile)
        setIsLoading(false)
      });
    }
  }, []);

  // if (!token || user.type !== "worker") {
  //   return (
  //     <div
  //       className="d-flex flex-column justify-content-center align-items-center gap-4"
  //       style={{ height: "100vh" }}
  //     >
  //       {token && user.type !== "worker" ? (
  //         <h1>Su usuario no puede acceder a esta página</h1>
  //       ) : (
  //         <h1>Debes iniciar sesión para poder acceder a esta página</h1>
  //       )}
  //       <Link className="theme-btn btn-style-five" to="/">
  //         Volver al inicio
  //       </Link>
  //     </div>
  //   );
  // }

  const handleChangeStep = (back?: boolean) => {
    if (back) {
      setCurrentStep(currentStep - 1);
    } else {
      setCurrentStep(currentStep + 1);
    }
  };

  return (
    <>
      <header className="d-flex flex-column justify-content-center align-items-center sm:py-3 pt-28" >
        {currentStep === 0 && <ProgressBarStep1 style={{ maxWidth: "100%" }} />}
        {currentStep === 1 && <ProgressBarStep2 style={{ maxWidth: "100%" }} />}

        {/* <JandiLogo  style={{ maxWidth: "90%", marginTop: "1rem" }} /> */}
        {isLoading && <Spinner isLoading={isLoading} size="lg" />}
      </header>
     
      {currentStep === 0 && (
        <UpdateWorkerStep1
          handleChangeStep={handleChangeStep}
          workerProfile={worker}
        />
      )}
      {currentStep === 1 && (
        <UpdateWorkerStep2
          handleChangeStep={handleChangeStep}
          workerProfile={worker}
        />
      )}
    </>
  );
}
